const optimizelyUtils = {
  // Optimizely script is now loaded directly in the HTML head
  // No initialization needed since script loads on page load
  track: () => {
    // @ts-ignore
    window.optimizely = window.optimizely || [];

    // optimizely object matches that of rental-manager-web
    // @ts-ignore
    window.optimizely.push({
      type: 'event',
      eventName: 'ltleases_cta',
      tags: {
        revenue: 0,
        value: 0.0,
      },
    });
  },
};

export default optimizelyUtils;
